module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"Actualiser le contenu","touDialogConfirmLabel":"Se connecter et accepter les conditions","touDialogTitle":"Conditions d’utilisation d’Adobe Experience Cloud","touTextLine1":"Les conditions d’utilisation d’Adobe Experience Cloud ont été mises à jour.","touTextLine2a":"Connectez-vous à","touTextLine2b":"et acceptez les conditions mises à jour avant de procéder.","touTextLine3":"Après avoir accepté les conditions, cliquez sur Actualiser le contenu."}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/fr_fr.json
// module id = 916
// module chunks = 0